__turbopack_context__.v({
  "addressRow": "TransactionDetailPage-module__z2LFCa__addressRow",
  "arrow": "TransactionDetailPage-module__z2LFCa__arrow",
  "badge": "TransactionDetailPage-module__z2LFCa__badge",
  "container": "TransactionDetailPage-module__z2LFCa__container",
  "copyButton": "TransactionDetailPage-module__z2LFCa__copyButton",
  "detailCard": "TransactionDetailPage-module__z2LFCa__detailCard",
  "gasBar": "TransactionDetailPage-module__z2LFCa__gasBar",
  "gasBarFill": "TransactionDetailPage-module__z2LFCa__gasBarFill",
  "gasBarTrack": "TransactionDetailPage-module__z2LFCa__gasBarTrack",
  "hashFull": "TransactionDetailPage-module__z2LFCa__hashFull",
  "header": "TransactionDetailPage-module__z2LFCa__header",
  "label": "TransactionDetailPage-module__z2LFCa__label",
  "link": "TransactionDetailPage-module__z2LFCa__link",
  "loading": "TransactionDetailPage-module__z2LFCa__loading",
  "rawInput": "TransactionDetailPage-module__z2LFCa__rawInput",
  "row": "TransactionDetailPage-module__z2LFCa__row",
  "skeleton": "TransactionDetailPage-module__z2LFCa__skeleton",
  "skeletonShimmer": "TransactionDetailPage-module__z2LFCa__skeletonShimmer",
  "statusBadge": "TransactionDetailPage-module__z2LFCa__statusBadge",
  "statusFailed": "TransactionDetailPage-module__z2LFCa__statusFailed",
  "statusSuccess": "TransactionDetailPage-module__z2LFCa__statusSuccess",
  "tab": "TransactionDetailPage-module__z2LFCa__tab",
  "tabActive": "TransactionDetailPage-module__z2LFCa__tabActive",
  "tabs": "TransactionDetailPage-module__z2LFCa__tabs",
  "title": "TransactionDetailPage-module__z2LFCa__title",
  "tokenTransferRow": "TransactionDetailPage-module__z2LFCa__tokenTransferRow",
  "tokenTransfers": "TransactionDetailPage-module__z2LFCa__tokenTransfers",
  "value": "TransactionDetailPage-module__z2LFCa__value",
});
